import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Observable, Subscription } from 'rxjs';
import { ConfigurationType } from '../../../../../domain/consts';
import { Policy } from '../../../../../domain/policy.model';
import { SummaryType } from '../../../../../domain/product.domain';
import { IOfferState } from '../../../store/ioffer.state';

@Component({
    selector: 'app-ipolicy',
    templateUrl: './ipolicy.component.html',
    styleUrls: ['./ipolicy.component.scss']
})
export class IPolicyComponent implements OnInit, OnDestroy {

    @Select(IOfferState.getPolicies) policies$: Observable<Policy[]>;
    subscriptions: Subscription[] = [];
    policyList: Policy[];
    summaryType = SummaryType;
    configurationType = ConfigurationType;

    get policyNumber() {
        return this.policyList.map(p => p.number).join(', ');
    }

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.policies$.subscribe(policies => this.policyList = cloneDeep(policies))
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

}
